export default __webpack_public_path__ + "static/media/sasktel-blue.86769cfd.png";